<template>
	<div class="container mx-auto p-4">
		<div class="swagger-container">
			<div id="swagger-ui"></div>
		</div>
	</div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useHead } from '#app';

// 添加Swagger UI的CSS样式和脚本
useHead({
	link: [
		{
			rel: 'stylesheet',
			href: '/swagger-ui/swagger-ui.css'
		}
	],
	script: [
		{
			src: '/swagger-ui/swagger-ui-bundle.js',
			body: true
		},
		{
			src: '/swagger-ui/swagger-ui-standalone-preset.js',
			body: true
		}
	]
});
async function sha256Encrypt(str) {
	const encoder = new TextEncoder();
	const data = encoder.encode(str);
	const hashBuffer = await crypto.subtle.digest('SHA-256', data);
	const hashArray = Array.from(new Uint8Array(hashBuffer));
	const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
	return hashHex;
}
onMounted(async () => {
	// 确保SwaggerUIBundle已加载	
	if (localStorage.getItem('isPass') !== 'yes') {
		document.getElementById("swagger-ui").style.display = "none";
		let password = prompt("请输入查看密码：", "");
		while (true) {
			// password = 'vlan';
			if (password == 'vlan') {
				break;
			} else {
				password = prompt("密码错误，请重新输入：", "");
			}
		}
		document.getElementById("swagger-ui").style.display = "block";
		localStorage.setItem('isPass', 'yes');
	}
	const checkSwaggerLoaded = () => {
		if (window.SwaggerUIBundle) {
			// 初始化Swagger UI
			window.SwaggerUIBundle({
				dom_id: '#swagger-ui',
				url: '/api/docs/openapi', // 使用动态生成的OpenAPI规范
				deepLinking: true,
				layout: 'BaseLayout',
				docExpansion: 'list',
				defaultModelsExpandDepth: 1,
				defaultModelExpandDepth: 1
			});
		} else {
			// 如果还没加载完成，等待100ms后再次检查
			setTimeout(checkSwaggerLoaded, 100);
		}
	};

	// 开始检查
	checkSwaggerLoaded();
});
</script>

<style>
.swagger-container {
	margin: 0 auto;
	max-width: 1200px;
	padding: 20px;
	background-color: white;
	border-radius: 8px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* 覆盖Swagger UI的一些样式 */
.swagger-ui .topbar {
	display: none;
}
</style>
